import type { ScatterPlotDatum, ScatterPlotNodeProps } from '@nivo/scatterplot'
import { animated } from '@react-spring/web'

export const SquareNode = (props: ScatterPlotNodeProps<ScatterPlotDatum>) => {
  const node = props.node
  const AnimatedRect = animated.rect as any
  return (
    <AnimatedRect
      x={node.x - node.size / 2}
      y={node.y - node.size / 2}
      width={node.size}
      height={node.size}
      fill={node.color}
      style={{ mixBlendMode: props.blendMode }}
    />
  )
}
